import React, { useState, useEffect } from "react";
import { Button } from "./button";

export const EnhancedInstructionsModal = ({
  open,
  onClose,
  initialInstructions,
  onSave,
  isLoading,
}) => {
  const [instructions, setInstructions] = useState(initialInstructions || "");

  // Reset state when modal opens/closes or initial value changes
  useEffect(() => {
    if (open) {
      setInstructions(initialInstructions || "");
    }
  }, [initialInstructions, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSave) {
      onSave(instructions.trim());
    }
  };

  const handleCancel = () => {
    setInstructions(initialInstructions || "");
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg w-full max-w-lg shadow-xl max-h-[90vh] flex flex-col">
        {/* Fixed Header */}
        <div className="p-6 pb-4 flex-shrink-0">
          <h3 className="text-lg font-semibold">Add Instructions</h3>
        </div>

        {/* Scrollable Content */}
        <div className="px-6 flex-1 overflow-y-auto">
          {/* Show current instructions if they exist */}
          {initialInstructions && (
            <div className="mb-4 p-3 bg-gray-50 rounded border">
              <p className="text-sm font-medium text-gray-700 mb-2">
                Current Instructions:
              </p>
              <div className="text-sm text-gray-600 whitespace-pre-wrap max-h-40 overflow-y-auto">
                {initialInstructions}
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="instructions"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                {initialInstructions
                  ? "Update Instructions:"
                  : "New Instructions:"}
              </label>
              <textarea
                id="instructions"
                className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none h-32 overflow-y-auto"
                placeholder="Enter instructions for this collection..."
                value={instructions}
                onChange={(e) => setInstructions(e.target.value)}
                disabled={isLoading}
              />
            </div>
          </form>
        </div>

        {/* Fixed Footer */}
        <div className="p-6 pt-4 flex-shrink-0 border-t bg-gray-50">
          <div className="flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-blue-500 text-white"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save Instructions"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
